import type { Locale } from '@ps/web-shared-generated-graphql/MTT';

const locales = [
  'BG',
  'CS',
  'DA',
  'DE',
  'EL',
  'EN',
  'EN_GB',
  'EN_IN',
  'EN_US',
  'ES',
  'ES_LA',
  'ET',
  'FI',
  'FR',
  'HR',
  'HU',
  'IT',
  'JA',
  'KO',
  'LT',
  'LV',
  'NL',
  'NO',
  'PL',
  'PT',
  'PT_BR',
  'RO',
  'RU',
  'SK',
  'SL',
  'SV',
  'UK',
  'ZH_CN',
  'ZH_TW'
];

const isLocale = (s: string): s is Locale => locales.includes(s);

export const mapStringToLocale = (lang: string): Locale => {
  const formattedLang = lang.toUpperCase().replace('-', '_');

  return isLocale(formattedLang) ? formattedLang : 'EN';
};
